var _path, _path2, _rect, _rect2, _rect3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayout4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 160 90"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M0 0h160v90H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M82 18h72v15H82zM6 18h72v15H6z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 6,
  x: 44,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 6,
  x: 138,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 6,
  x: 6,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M82 35h72v15H82zM6 35h72v15H6zM82 52h72v15H82zM6 52h72v15H6zM82 69h72v15H82zM6 69h72v15H6z"
})));
export { SvgLayout4 as ReactComponent };